<template>
  <v-dialog v-model="individual_dialog" @click:outside="closeIndividualDialog" max-width="600px">
    <v-card class="pb-2">
      <v-toolbar dense color="red lighten-1">
        <v-toolbar-title class="white--text">Imposto de renda</v-toolbar-title>
      </v-toolbar>

      <v-card-title>Inserir Imposto de Renda</v-card-title>
      <v-card-title>{{ selected_emp.full_name }}</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-select
              v-model="$v.form.year.$model"
              dense
              outlined
              label="Ano"
              :items="yearsFactory()"
              hide-details="auto"
            ></v-select>
          </v-col>
          <v-col cols="12">
            <v-file-input
              v-model="$v.form.doc.$model"
              show-size
              :rules="rules"
              accept="application/pdf"
              placeholder="Selecione um documento PDF"
              prepend-icon="mdi-file-pdf"
              label="Imposto de Renda"
              hide-details="auto"
            ></v-file-input>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="d-flex justify-space-between mx-4">
        <v-btn color="red" class="white--text" @click="closeIndividualDialog">Cancelar</v-btn>
        <v-btn color="green" class="white--text" @click="storeIncomeTax">Enviar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
//    :error-messages="errors.data.doc"
//               @change="errorMensage('doc')"
//               @blur="errorMensage('doc')"
import { required } from 'vuelidate/src/validators'
import { mapActions } from 'vuex'
export default {
  name: 'ITIndividualUpload',
  props: ['individual_dialog', 'closeIndividualDialog', 'selected_emp'],
  data: () => {
    return {
      form: { doc: [], year: '' },
      rules: [(value) => !value || value.size < 1000000 || 'Aquivo deve ser menor de que 1 Mega'],
    }
  },
  methods: {
    ...mapActions('employees', ['ActionStoreIncomeTaxesIndividual']),
    ...mapActions('ui', ['ActionSetLoading']),
    storeIncomeTax() {
      this.ActionSetLoading(true)
      try {
        this.$v.$touch()
        if (this.$v.form.$invalid) {
          this.$swal({
            icon: 'error',
            title: 'Erro',
            text: 'Existem campos vazios',
          })
          this.ActionSetLoading(false)
          return
        }
        const income_tax = new FormData()
        income_tax.append('files', this.form.doc, this.form.doc.name)
        income_tax.append('employee_id', this.selected_emp.id)
        income_tax.append('year', this.form.year)
        this.ActionStoreIncomeTaxesIndividual(income_tax)
        this.closeIndividualDialog()
        this.clearForm()
        this.$swal({
          icon: 'success',
          title: 'Cadastrado',
          text: 'Imposto de Renda cadastrado com sucesso',
        })
      } catch (error) {
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: error.body.message,
        })
      }
      this.ActionSetLoading(false)
    },
    clearForm() {
      this.form = { doc: [], year: '' }
    },
    yearsFactory() {
      const years = []
      const currentYear = new Date().getFullYear()
      const totalYears = 2

      for (let i = 0; i <= totalYears; i++) {
        years.push(currentYear - i)
      }

      return years
    },
  },
  validations: { form: { doc: { required }, year: { required } } },
}
</script>
